import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Location } from '@angular/common';



@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrl: './user-table.component.scss'
})
export class UserTableComponent {
  translator: TranslatorPipe = new TranslatorPipe()
  @Input() data: any[] = [];
  @Input() columns: string[] = [];
  @Input() loading: boolean = false;
  @Input() action: number = 0;
  @Input() goBackBtn: boolean = true;
  @Input() pagging: boolean = false;
  @Input() messages: any[] = [];
  @Input() totalCount: number = 0;
  @Input() first: number = 1;
  @Input() rows: number = 10;
  @Input() TotalScore: number = 0;
  @Input() assessmentId: string = "";
  @Input() from: string = "assessment";
  @Output() actionClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateDataEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedUsersChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  selectAllUsersFlag: boolean = false;
  selectedUsers: string[] = [];
  locationOrigin: string = window.location.origin;



 
  openQuestionModal: boolean = false;
  resultId: string = "";
  questionsToShow: any[] = [];
  openEndedQuestionsToShow: any[] = [];
  scoreHideQuestions: string[] = ['PRESENTATION_TEXT','SECTION_HEADING','SECTION_SUB_HEADING'];
  openEndedQuestions: string[] = ["SINGLE_ROW_TEXT","EMAIL_ADDRESS","COMMENT_BOX","CONTACT_INFO"];
  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private location: Location,
    private dataService: DataService,
  ) { }

  ngOnInit() {
    if(this.data && this.data.length > 0){
      this.TotalScore = this.data[0].totalMarks;
      console.log("this.data",this.data);
    }
  }

  getColumnValue(attendee: any, column: string, type: number): any {
    if (attendee) {
      switch (column) {
        case 'the name':
          return (type === 1) ? (attendee.user ? this.getName(attendee.user.name) : "-") : (attendee.name ? this.getName(attendee.name) : (attendee?.externalName ? attendee?.externalName : '-') );
        case 'E-mail':
          return (type === 1) ? (attendee.user ? attendee.user.email : "-") : (attendee.email ? attendee.email : "-");
        case 'Contact':
          return (type === 1) ? (attendee.user ? attendee.user.phone : "-") : (attendee.phone ? attendee.phone : "-");
        case 'Gender':
          return (type === 1) ? (attendee.user ? attendee.user.gender : "-") : (attendee.gender ? attendee.gender : "-");
        case 'Status':
          return attendee.status ? attendee.status : "-";
        case 'Mark Type':
          return attendee.markType ? attendee.markType : "-";
        case 'Marked At':
          return attendee.timestamp
            ? new Date(attendee.timestamp).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })
            : '-';
        case 'Score / Total Marks':
              return this.formatScore(attendee.score)
        case 'Percentage':
          return "% " + this.formatScore(attendee.percentage)
        case 'timeTaken':
          return attendee.timeTaken ? attendee.timeTaken : "Time not defined";
        case 'Result':
          return attendee.criteria ? attendee.criteria : "No Criteria Matched";
        case 'submittedTime':
          return attendee.attemptEndDate
          ? new Date(attendee.attemptEndDate).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          }) : "-";
        default:
          return '-';
      }
    } else {
      return 'Undefined';
    }
}


  formatScore(value: number) {
    if (value % 1 === 0 || value.toFixed(2).endsWith('.00')) {
      return Math.trunc(value);
    } else {
      return value.toFixed(2);
    }
  }

  getName(name: any): string {
    if (typeof name === 'object' && name !== null) {
      return Object.values(name).join(' ');
    } else {
      return name;
    }
  }

  confirmMark(email: string): void {
    this.actionClicked.emit(email);
  }

  goBack(): void {
    this.location.back();
  }

  ShowQuestions(data: any)
  {
    this.resultId = data.resultId;
    this.questionsToShow = data.questions;
    this.openEndedQuestionsToShow = data.questions.filter((question: any) => question.score == 0 
    && question.meta.marks > 0
    && this.openEndedQuestions.includes(question.type) ).length;
    this.openQuestionModal = true;
  }

  async AllowRedo(attendee: any, type: number)
  {
    const email = (type === 1) ? (attendee.user ? attendee.user.email : null) : (attendee.email ? attendee.email : null);
    if (email)
    {
      try {
        await this.deleteCache(email);
        let res = await this.dataService.postData(`${this.from}-attempt/` + this.assessmentId + "/" + email,null, 'POST', false);
        if (res.error) {
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ]
          return;
        }
        this.messages = [
          { severity: 'success', summary: this.translate('success') },
        ];
        this.updateDataEvent.emit({});
      } catch (e) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: e },
        ]
      }
    }
  }

  async deleteCache(email:any) {
    await this.dataService.postData('cache-controller/delete', { email: email, surveyId: this.assessmentId })
  }

  hasOpenEndedQuestions(questions: any[]): boolean {
    if (questions)
    {
      const openEndedCount = questions.filter(question => question.score == 0 
        && question.meta.marks > 0 
        && this.openEndedQuestions.includes(question.type) ).length;
      return openEndedCount > 0;
    }
    else{
      return true;
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async updateResults() {
    try {
      let postData: any = {
        _id: this.resultId,
        questions: this.questionsToShow,
      };
      let res = await this.dataService.postData("assessment-result",postData, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.generateResults();
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.updateDataEvent.emit({});
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ]
    }
  }

  async generateResults() {
    try {
      let res = await this.dataService.postData(
        `${this.from}-result/generate`,
        ''
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
    } catch (e) { }
  }

  // async updateShowResult() {
  //   try {
  //     let postData: any = {
  //       _id: id,
  //       showResult: showResult,
  //     };
  //     let res = await this.dataService.postData("assessment-result",postData, 'PUT', false);
  //     if (res.error) {
  //       this.messages = [
  //         { severity: 'error', summary: this.translate('error'), detail: res.msg },
  //       ]
  //       return;
  //     }
  //     this.messages = [
  //       { severity: 'success', summary: this.translate('success') },
  //     ];
  //     this.updateDataEvent.emit({});
  //   } catch (e) {
  //     this.messages = [
  //       { severity: 'error', summary: this.translate('error'), detail: e },
  //     ]
  //   }
  // }

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }

  toggleSelectAll() {
    if (this.selectAllUsersFlag) {
      this.selectedUsers = this.data.map(data => 
        data.user ? data.user.email : data.email
      );
    } else {
      this.selectedUsers = [];
    }
    this.selectedUsersChange.emit(this.selectedUsers);
  }

  AddUserEmailToList(attendee: any) {
    const email = attendee.user ? attendee.user.email : attendee.email;

    const index = this.selectedUsers.indexOf(email);
    if (index > -1) {
      this.selectedUsers.splice(index, 1);
    } else if (email) {
      this.selectedUsers.push(email);
    }
    this.selectedUsersChange.emit(this.selectedUsers);
  }

  isUserSelected(attendee: any): boolean {
    const email = attendee.user ? attendee.user.email : attendee.email;
    return this.selectedUsers.includes(email);
  }

  getCorrect(question: any) {
    if (!question || !question.meta) {
      return null;
    }
  
    const fieldsValueTypes = ["STAR_RATING", "RANK_ORDER", "DRAG_DROP"];
    const fieldsFieldValueTypes = ["MULTI_POINT_SCALE"];
    const metaValueTypes = ["SELECT_ONE", "DROPDOWN_MENU", "SELECT_ONE_IMAGE", "SMILE_RATING", "CALENDAR"];
    const metaValueArrayTypes = ["SELECT_MANY", "SELECT_MANY_IMAGE"];
    const fieldsValueArrayTypes = ["MULTI_SELECT_SCALE"];
    const dateTypes = ["DATE_TIME"];
  
    if (metaValueTypes.includes(question.type)) {
      if (question.meta.correct !== null && question.meta.correct !== undefined) {
        return question.meta.correct;
      }
    }
  
    if (metaValueArrayTypes.includes(question.type)) {
      if (Array.isArray(question.meta.correct) && question.meta.correct.length > 0) {
        return question.meta.correct;
      }
    }
  
    if (fieldsValueTypes.includes(question.type)) {
      if (Array.isArray(question.meta.fields)) {
        const correctAnswers = question.meta.fields
          .map((field: any) => field.correct)
          .filter((correct: any) => correct !== null && correct !== undefined);
  
        return correctAnswers.length > 0 ? correctAnswers : null;
      }
    }
  
    if (fieldsFieldValueTypes.includes(question.type)) {
      if (Array.isArray(question.meta.fields)) {
        const correctAnswers = question.meta.fields
          .map((field: any) => field.field && field.field.correct)
          .filter((correct: any) => correct !== null && correct !== undefined);
  
        return correctAnswers.length > 0 ? correctAnswers : null;
      }
    }
  
    if (fieldsValueArrayTypes.includes(question.type)) {
      if (Array.isArray(question.meta.fields)) {
        const correctAnswers = question.meta.fields
          .filter((field: any) => Array.isArray(field.correct) && field.correct.length > 0)
          .map((field: any) => field.correct);
  
        return correctAnswers.length > 0 ? correctAnswers : null;
      }
    }

    if (dateTypes.includes(question.type)) {
      if (typeof question.meta.correct === 'object' && question.meta.correct !== null) {
        const allValuesAreValid = Object.values(question.meta.correct).every((val: any) =>
          (typeof val === 'string' || typeof val === 'number') && val.toString().trim() !== ''
        );
  
        return allValuesAreValid ? question.meta.correct : null;
      }
    }
  
    return null;
  }

  async downlaodCertificate(email: string) {
    window.open('/assessment/certificate/' + this.assessmentId + '/' + email, '_blank');
  }

}

